import { Languages } from '../../enums/Languages';

export class LanguagesUtil {
    public static getLocaleString(language: Languages): string {
        let localeString = this.getByString(language);
        return localeString + "-" + localeString.toUpperCase();
    }
    public static getByString(language: string): Languages {

        if (!language)
            return Languages.es;

        for (const lang of Object.values(Languages)) {
            if (language === lang) return lang;
        }

        for (const lang of Object.values(Languages)) {
            if (language.startsWith(lang)) return lang;
        }

        return Languages.en;
    }
}